export const NAVIGATION_BAR_HEIGHT = 8.125
